module.exports = __webpack_public_path__ + "static/media/997689.943ae458.jpg";